import { render, staticRenderFns } from "./DetailAlbumsChat.vue?vue&type=template&id=3f8a9f9a&scoped=true&lang=html&"
import script from "./DetailAlbumsChat.vue?vue&type=script&lang=js&"
export * from "./DetailAlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./DetailAlbumsChat.vue?vue&type=style&index=0&id=3f8a9f9a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a9f9a",
  null
  
)

export default component.exports